import { render, staticRenderFns } from "./SamBadge.vue?vue&type=template&id=5aba47ea&scoped=true&shadow"
import script from "./SamBadge.vue?vue&type=script&lang=js&shadow"
export * from "./SamBadge.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamBadge.vue?vue&type=style&index=0&id=5aba47ea&prod&scoped=true&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5aba47ea",
  null
  ,true
)

export default component.exports